/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
export const CONSULTAR_OFERTA = "ventaTC/wp/post";
export const CONSULTAR_ES_CLIENTE = "segurosVehiculo/consultarCliente";
export const CONSULTAR_DATOS_PATENTE = "segurosVehiculo/obtenerDatosPorPatente";
export const CONSULTAR_MARCAS_AUTO = "segurosVehiculo/obtenerMarcas";
export const CONSULTAR_MODELOS_AUTO = "segurosVehiculo/obtenerModelos";
export const CONSULTAR_VERSION_AUTO = "segurosVehiculo/obtenerSubmodelos";
export const CONSULTAR_SIMULACION_COTIZACION =
  "segurosVehiculo/obtenerCotizaciones";
export const OBTENER_TIPOS_VIVIENDA = "segurosHogar/obtenerTiposDeVivienda";
export const OBTENER_COTIZACION_HOGAR =
  "segurosHogar/obtenerCotizacionCoberturas";
export const OBTENER_RECOTIZACION_HOGAR =
  "segurosHogar/obtenerRecotizacionCoberturas";
export const OBTENER_PDF_HOGAR = "segurosHogar/obtenerPdfSegurosHogar";
export const POST_QUIERO_ME_CONTACTEN = "segurosVehiculo/quieroQueMeContacten";
